import { render } from "./CostoCreate.vue?vue&type=template&id=1301f69e&scoped=true"
import script from "./CostoCreate.vue?vue&type=script&lang=js"
export * from "./CostoCreate.vue?vue&type=script&lang=js"

import "./CostoCreate.vue?vue&type=style&index=0&id=1301f69e&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1301f69e"]])

export default __exports__